module.exports = __webpack_public_path__ + "static/media/flag-bs.41a4f5b9.webp";